<template>
    <div class="instruction-cards">
        <div class="instruction-card">
            <div class="instruction-icon">
                <font-awesome-icon :icon="['far', isMobile ? 'user' : 'user']" />
            </div>
            <div class="instruction-content">
                <h4>{{ isMobile ? $t('sign_feedback.direct_record.mobile.position_stable.title') : $t('sign_feedback.direct_record.position.title') }}</h4>
                <p>{{ isMobile ? $t('sign_feedback.direct_record.mobile.position_stable.description') : $t('sign_feedback.direct_record.position.description') }}</p>
            </div>
        </div>

        <div class="instruction-card">
            <div class="instruction-icon">
                <font-awesome-icon :icon="['far', isMobile ? 'camera' : 'eye']" />
            </div>
            <div class="instruction-content">
                <h4>{{ isMobile ? $t('sign_feedback.direct_record.mobile.selfie_camera.title') : $t('sign_feedback.direct_record.lighting.title') }}</h4>
                <p>{{ isMobile ? $t('sign_feedback.direct_record.mobile.selfie_camera.description') : $t('sign_feedback.direct_record.lighting.description') }}</p>
            </div>
        </div>

        <div class="instruction-card">
            <div class="instruction-icon">
                <font-awesome-icon :icon="['far', isMobile ? 'user' : 'desktop']" />
            </div>
            <div class="instruction-content">
                <h4>{{ isMobile ? $t('sign_feedback.direct_record.mobile.fullframe.title') : $t('sign_feedback.direct_record.distance.title') }}</h4>
                <p>{{ isMobile ? $t('sign_feedback.direct_record.mobile.fullframe.description') : $t('sign_feedback.direct_record.distance.description') }}</p>
            </div>
        </div>

        <div class="instruction-card">
            <div class="instruction-icon">
                <font-awesome-icon :icon="['far', isMobile ? 'desktop' : 'camera']" />
            </div>
            <div class="instruction-content">
                <h4>{{ isMobile ? $t('sign_feedback.direct_record.mobile.background.title') : $t('sign_feedback.direct_record.background.title') }}</h4>
                <p>{{ isMobile ? $t('sign_feedback.direct_record.mobile.background.description') : $t('sign_feedback.direct_record.background.description') }}</p>
            </div>
        </div>

        <div v-if="isMobile" class="quick-setup mt-3">
            <div class="quick-setup__title">{{ $t('sign_feedback.direct_record.quick_setup.title') }}</div>
            <ul class="quick-setup__list">
                <li><span class="index">1</span>{{ $t('sign_feedback.direct_record.quick_setup.step1') }}</li>
                <li><span class="index">2</span>{{ $t('sign_feedback.direct_record.quick_setup.step2') }}</li>
                <li><span class="index">3</span>{{ $t('sign_feedback.direct_record.quick_setup.step3') }}</li>
                <li><span class="index">4</span>{{ $t('sign_feedback.direct_record.quick_setup.step4') }}</li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DirectRecordTips extends Vue {
    public isMobile: boolean = false;

    public mounted(): void {
        const update = () => (this.isMobile = window.innerWidth < 768);
        update();
        window.addEventListener('resize', update);
        this.$once('hook:beforeDestroy', () => window.removeEventListener('resize', update));
    }
}
</script>

<style lang="scss" scoped>
.instruction-cards {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.instruction-card {
    display: flex;
    align-items: flex-start;
    padding: 0.6rem;
    border-radius: 8px;
    border: 1px solid #EAEAEA;
    gap: 0.6rem;
}

@include media-breakpoint-up(sm) {
    .instruction-cards.instruction-cards {
        gap: 8px;
    }
    .instruction-card {
        padding: 0.75rem;
        gap: 0.75rem;
    }
}

@include media-breakpoint-up(md) {
    .instruction-cards.instruction-cards {
        gap: 10px;
    }
    .instruction-card {
        padding: 0.9rem;
        gap: 0.9rem;
    }
}

@include media-breakpoint-up(lg) {
    .instruction-cards.instruction-cards {
        gap: 12px;
    }
    .instruction-card {
        padding: 1rem;
        gap: 1rem;
    }
}

.instruction-icon {
    color: #4362AD;
    font-size: 1rem;
    min-width: 2rem;
    max-width: 2rem;
    text-align: center;
    background-color: #E5ECFF;
    border-radius: 8px;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.instruction-content h4 {
    color: #666060;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 100%;
    letter-spacing: 0%;
    margin-bottom: 0.3rem;
}

.instruction-content p {
    color: #666060;
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0%;
    margin: 0;
}

@include media-breakpoint-up(md) {
    .instruction-content h4 {
        font-size: 15px;
    }
    .instruction-content p {
        font-size: 14px;
        line-height: 18px;
    }
}

@include media-breakpoint-up(lg) {
    .instruction-content h4 {
        font-size: 16px;
    }
    .instruction-content p {
        font-size: 15px;
        line-height: 20px;
    }
}

.quick-setup {
    background-color: #E5ECFF;
    border: 1px solid #C9D6FF;
    border-radius: 8px;
    padding: 0.75rem;
}

.quick-setup__title {
    color: #4362AD;
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    margin-bottom: 0.5rem;
}

.quick-setup__list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.quick-setup__list li {
    display: flex;
    align-items: center;
    color: #4362AD;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    margin: 0.25rem 0;
}

.quick-setup__list .index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 0.25rem;
    background-color: #C9D6FF;
    color: #273F7A;
    font-size: 0.85rem;
    margin-right: 0.5rem;
}

@include media-breakpoint-down(xl) {
    .instruction-cards--grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
    }
}
</style>


